export const WRITING_SKELETON_LINE_HEIGHT_PX = 16;

export const WRITING_SKELETON_CORNER_RADIUS = '4px';

export const COMMON_CAPTION_ROW_HEIGHT_PX = 49;

export const CAPTION_TAGS_POPOVER_ALREADY_SHOWN = 'tags_popover_already_shown';

export const USER_HAS_SEEN_MAX_TAGS_POPOVERS = 'user_has_seen_max_tags_popovers';
